import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

import BottomNavigationMobile from "../../../../vendorDashboardComponents/navigationSection/BottomNavigationMobile";
// import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../../../vendorDashboardComponents/navigationSection/RightSideNavigation";
import ReportsDashboardOne from "./reportsDashboard/ReportsDashboardOne";
// import ReportsDashboardTwo from "./reportsDashboard/ReportsDashboardTwo";
// import OffersReports from "./offerReports/OffersReports";
import EventsReports from "./eventReports/EventsReports";
// import SeatingReportsDashboard from "./seatingReports/SeatingReportsDashboard";

import { Col } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import SVG from "react-inlinesvg";
import Media from "react-media";
import moment from "moment";
// import ReportsDashboardOffers from "./reportsDashboard/ReportsDashboardOffers";
// import ReportsDashboardEvents from "./reportsDashboard/ReportsDashboardEvents";
import ReportsDashboardOrders from "./reportsDashboard/ReportsDashboardOrders";
import { LeftSideNavigation } from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

class SuperAdminMainReportsDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openPax: false,
      showStatus: "All",
      showPax: "All",
      displayTab: "reportsOne",
      rightSideTab: "reportsOne",
      dateFilter: moment(new Date()).format("YYYY-MM-DD"),
      dateTo: moment(new Date()).format("YYYY-MM-DD"),
      dateFrom: moment(new Date()).format("YYYY-MM-DD"),
      reportType: "monthly",
    };
  }

  /****************************************
   * @DESC Open Modal
   ***************************************/
  onOpenModal = () => {
    this.setState({ open: true });
  };
  onCloseModal = () => {
    this.setState({ open: false });
  };
  onOpenModalPax = () => {
    this.setState({ openPax: true });
  };
  onCloseModalPax = () => {
    this.setState({ openPax: false });
  };

  /****************************************
    @DESC Big Button Show Status Handler
   ***************************************/
  bigButtonShowStatusHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      showStatus: type,
      open: false,
    });
  };

  bigButtonShowPaxHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      showPax: type,
      openPax: false,
    });
  };

  /****************************************
   * @DESC Button Show Status Handler
   ***************************************/
  buttonClickHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      displayTab: type,
      rightSideTab: type,
    });
  };

  reportTypeHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      reportType: type,
    });
  };

  changeDate = (e) => this.setState({ dateFilter: e.target.value });
  onFromDateChange = (e) => this.setState({ dateFrom: e.target.value });
  onToDateChange = (e) => this.setState({ dateTo: e.target.value });

  render() {
    // console.log(this.state);
    const { dateFilter } = this.state;
    return (
      <React.Fragment>
        <Container fluid>
          <Row>
            <Media query="(min-width: 992px)">
              <div className="left-side-panel">
                <LeftSideNavigation displayLink={1} />
              </div>
            </Media>
            {/* <div className="top-panel">
              <TopNavigationBarMobile
                displayLeft="backButton"
                backLink="/seatingdashboard"
                headText="Seating Report"
              />
            </div> */}
            <div className="right-side-panel">
              <RightSideNavigation />
              <Row className="align-items-center mb-5">
                <Col md={6} className="f24_700_HelveticaNeue">
                  Report Live Dashboard
                </Col>
                {/* <Col md={6} className="text-right"> */}
                {/* {this.state.displayTab === "reportsOne" ||
                  this.state.rightSideTab === "reportsTwo" ? ( */}
                {/* <TextField
                    type="date"
                    variant="outlined"
                    value={dateFilter}
                    onChange={this.changeDate}
                  /> */}
                {/* ) : null} */}
                {/* </Col> */}
              </Row>
              <Row>
                <div className="col-lg-4 d-flex flex-wrap">
                  <div
                    className={
                      this.state.displayTab === "reportsOne" ||
                        this.state.rightSideTab === "reportsTwo" ||
                        this.state.displayTab === "seatingDdashboard"
                        ? "enIconBtnWithTxt mr-5 active"
                        : "enIconBtnWithTxt mr-5"
                    }
                    onClick={(e) => this.buttonClickHandler(e, "reportsOne")}
                  >
                    <SVG
                      src={require("../../../../../assets/images/UserManagement/seating.svg")}
                      alt="seating"
                    />
                    <div
                      className={
                        this.state.displayTab === "reportsOne" ||
                          this.state.rightSideTab === "reportsTwo" ||
                          this.state.displayTab === "seatingDdashboard"
                          ? "f14-500 text-red"
                          : "f14-500"
                      }
                    >
                      Seating
                    </div>
                  </div>
                  <div
                    className={
                      this.state.displayTab === "reportsoffersOne" ||
                        this.state.displayTab === "reportsoffersTwo"
                        ? "enIconBtnWithTxt mr-5 active"
                        : "enIconBtnWithTxt mr-5"
                    }
                    onClick={(e) =>
                      this.buttonClickHandler(e, "reportsoffersOne")
                    }
                  >
                    <SVG
                      src={require("../../../../../assets/images/UserManagement/offer.svg")}
                      alt="seating"
                    />
                    <div
                      className={
                        this.state.displayTab === "reportsoffersOne" ||
                          this.state.displayTab === "reportsoffersTwo"
                          ? "f14-500 text-red"
                          : "f14-500"
                      }
                    >
                      Offers
                    </div>
                  </div>
                  <div
                    className={
                      this.state.displayTab === "events"
                        ? "enIconBtnWithTxt mr-5 active"
                        : "enIconBtnWithTxt mr-5"
                    }
                    onClick={(e) => this.buttonClickHandler(e, "events")}
                  >
                    <SVG
                      src={require("../../../../../assets/images/UserManagement/event.svg")}
                      alt="seating"
                    />
                    <div
                      className={
                        this.state.displayTab === "events"
                          ? "f14-500 text-red"
                          : "f14-500"
                      }
                    >
                      Events
                    </div>
                  </div>
                  <div
                    className={
                      this.state.displayTab === "ordering"
                        ? "enIconBtnWithTxt active"
                        : "enIconBtnWithTxt"
                    }
                    onClick={(e) => this.buttonClickHandler(e, "ordering")}
                  >
                    <SVG
                      src={require("../../../../../assets/images/Menu/vendor/3.svg")}
                      alt="ordering"
                    />
                    <div
                      className={
                        this.state.displayTab === "ordering"
                          ? "f14-500 text-red"
                          : "f14-500 text-black"
                      }
                    >
                      Ordering
                    </div>
                  </div>
                </div>

                <div className="col-lg-8 d-flex justify-content-end align-items-center">
                  {/* {this.state.displayTab === "seatingDdashboard" ? ( */}
                  {/* // this.state.displayTab === "offers" || */}
                  {/* // this.state.displayTab === "events" */}
                  <div className="w-100 row justify-content-end">
                    <Col md={6} lg={6}>
                      <div className="f12-500 mb-1">Starts Date</div>
                      <TextField
                        type="date"
                        className="w-100"
                        variant="outlined"
                        onChange={this.onFromDateChange}
                      />
                    </Col>
                    <Col md={6} lg={6}>
                      <div className="f12-500 mb-1">Ends Date</div>
                      <TextField
                        type="date"
                        className="w-100"
                        variant="outlined"
                        onChange={this.onToDateChange}
                      />
                    </Col>
                    {/* <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 d-flex align-items-end">
                        <div className="report-seating-dashboard-button">
                          <div className="d-flex">
                            <div className="seating-dashboard-main">
                              <div>
                                <Image
                                  fluid
                                  src={require("../../../../../assets/images/ActionImages/calendar.png")}
                                  alt="Previous Date"
                                  title="Previous Date"
                                />
                                <p>From</p>
                              </div>
                              <div className="date-display-box">
                                <h5>
                                  09 <span>Mar 20 Monday</span>
                                </h5>
                              </div>
                            </div>
                            <div className="seating-dashboard-main">
                              <div>
                                <Image
                                  fluid
                                  src={require("../../../../../assets/images/ActionImages/calendar.png")}
                                  alt="Previous Date"
                                  title="Previous Date"
                                />
                                <p>From</p>
                              </div>
                              <div className="date-display-box">
                                <h5>
                                  09 <span>Mar 20 Monday</span>
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    {/* <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 d-flex justify-content-between">
                        <div className="col">
                          <SeatingStatus
                            status={this.state.showStatus}
                            onOpenModal={this.onOpenModal}
                            onCloseModal={this.onCloseModal}
                            open={this.state.open}
                            seatingStatus={this.state.showStatus}
                            onClickAll={(e) =>
                              this.bigButtonShowStatusHandler(e, "All")
                            }
                            onClickSeated={(e) =>
                              this.bigButtonShowStatusHandler(e, "Seated")
                            }
                            onClickNonSeated={(e) =>
                              this.bigButtonShowStatusHandler(e, "Nonseated")
                            }
                          />
                        </div>
                        <div className="col">
                          <TableSizePopup
                            showPax={this.state.showPax}
                            onOpenModal={this.onOpenModalPax}
                            open={this.state.openPax}
                            onCloseModal={this.onCloseModalPax}
                            table_size={this.state.showPax}
                            onClickAll={(e) =>
                              this.bigButtonShowPaxHandler(e, "All")
                            }
                            onClickTwo={(e) =>
                              this.bigButtonShowPaxHandler(e, "2")
                            }
                            onClickFour={(e) =>
                              this.bigButtonShowPaxHandler(e, "4")
                            }
                            onClickSix={(e) =>
                              this.bigButtonShowPaxHandler(e, "6")
                            }
                            onClickEight={(e) =>
                              this.bigButtonShowPaxHandler(e, "8")
                            }
                            graterThanEight={(e) =>
                              this.bigButtonShowPaxHandler(e, "8>")
                            }
                          />
                        </div>
                      </div> */}
                  </div>
                  {/* // ) : null} */}
                  {/* {this.state.displayTab === "reportsOne" ||
                  this.state.displayTab === "reportsTwo" ? (
                    <React.Fragment>
                      <div
                        className={
                          this.state.displayTab === "reportsOne"
                            ? "f18-500 cursor text-red"
                            : "f18-500 cursor"
                        }
                        onClick={(e) =>
                          this.buttonClickHandler(e, "reportsOne")
                        }
                      >
                        Seating Report 1
                      </div>
                      <div className="borderRideSide"></div>
                      <div
                        className={
                          this.state.displayTab === "reportsTwo"
                            ? "f18-500 cursor text-red"
                            : "f18-500 cursor"
                        }
                        onClick={(e) =>
                          this.buttonClickHandler(e, "reportsTwo")
                        }
                      >
                        Seating Report 2
                      </div>
                    </React.Fragment>
                  ) : null}
                  {this.state.displayTab === "reportsoffersOne" ||
                  this.state.displayTab === "reportsoffersTwo" ? (
                    <React.Fragment>
                      <div
                        className={
                          this.state.displayTab === "reportsoffersOne"
                            ? "f18-500 cursor text-red"
                            : "f18-500 cursor"
                        }
                        onClick={(e) =>
                          this.buttonClickHandler(e, "reportsoffersOne")
                        }
                      >
                        Seating Report 1
                      </div>
                      <div className="borderRideSide"></div>
                      <div
                        className={
                          this.state.displayTab === "reportsoffersTwo"
                            ? "f18-500 cursor text-red"
                            : "f18-500 cursor"
                        }
                        onClick={(e) =>
                          this.buttonClickHandler(e, "reportsoffersTwo")
                        }
                      >
                        Seating Report 2
                      </div>
                    </React.Fragment>
                  ) : null}
                  {this.state.displayTab === "events" ||
                  this.state.displayTab === "eventstwo" ? (
                    <React.Fragment>
                      <div
                        className={
                          this.state.displayTab === "events"
                            ? "f18-500 cursor text-red"
                            : "f18-500 cursor"
                        }
                        onClick={(e) => this.buttonClickHandler(e, "events")}
                      >
                        Event Report 1
                      </div>
                      <div className="borderRideSide"></div>
                      <div
                        className={
                          this.state.displayTab === "eventstwo"
                            ? "f18-500 cursor text-red"
                            : "f18-500 cursor"
                        }
                        onClick={(e) => this.buttonClickHandler(e, "eventstwo")}
                      >
                        Event Report 2
                      </div>
                    </React.Fragment>
                  ) : null} */}
                  <div
                    className={`f18-500 cursor ${this.state.reportType === "hourly" && "text-red"
                      } ml-3 mr-3`}
                    onClick={(e) => this.reportTypeHandler(e, "hourly")}
                  >
                    Hourly
                  </div>
                  <div
                    className={`f18-500 cursor ${this.state.reportType === "daily" && "text-red"
                      } mr-3`}
                    onClick={(e) => this.reportTypeHandler(e, "daily")}
                  >
                    Daily
                  </div>
                  <div
                    className={`f18-500 cursor ${this.state.reportType === "weekly" && "text-red"
                      } mr-3`}
                    onClick={(e) => this.reportTypeHandler(e, "weekly")}
                  >
                    Weekly
                  </div>
                  <div
                    className={`f18-500 cursor ${this.state.reportType === "monthly" && "text-red"
                      } mr-3`}
                    onClick={(e) => this.reportTypeHandler(e, "monthly")}
                  >
                    Monthly
                  </div>
                  <div
                    className={`f18-500 cursor ${this.state.reportType === "custom" && "text-red"
                      } mr-3`}
                    onClick={(e) => this.reportTypeHandler(e, "custom")}
                  >
                    Custom
                  </div>
                </div>
              </Row>
              <hr />
              <div>
                {this.state.displayTab === "reportsOne" ? (
                  <div className="w-100 bottom-side-panel-reports">
                    <ReportsDashboardOne
                      dateFilter={dateFilter}
                      onClick={(e) =>
                        this.props.history.push("/seatingdashboard")
                      }
                      dateTo={this.state.dateTo}
                      dateFrom={this.state.dateFrom}
                      onFromDateChange={this.onFromDateChange}
                      onToDateChange={this.onToDateChange}
                      onDateChange={this.changeDate}
                      reportType={this.state.reportType}
                    />
                  </div>
                ) : null}
                {/* {this.state.displayTab === "reportsTwo" ? (
                  <div className="w-100 bottom-side-panel-reports">
                    <ReportsDashboardOne
                      dateFilter={dateFilter}
                      onClick={(e) =>
                        this.buttonClickHandler(e, "seatingDdashboard")
                      }
                      dateTo={this.state.dateTo}
                      dateFrom={this.state.dateFrom}
                      onFromDateChange={this.onFromDateChange}
                      onToDateChange={this.onToDateChange}
                      onDateChange={this.changeDate}
                    />
                  </div>
                ) : null} */}
                {/* {this.state.displayTab === "reportsoffersOne" ? (
                  <div className="w-100 bottom-side-panel-reports">
                    <ReportsDashboardOffers
                      dateFilter={dateFilter}
                      onClick={(e) =>
                        this.buttonClickHandler(e, "seatingDdashboard")
                      }
                      dateTo={this.state.dateTo}
                      dateFrom={this.state.dateFrom}
                      onFromDateChange={this.onFromDateChange}
                      onToDateChange={this.onToDateChange}
                      onDateChange={this.changeDate}
                    />
                  </div>
                ) : null} */}
                {/* {this.state.displayTab === "reportsoffersTwo" ? (
                  <div className="w-100 bottom-side-panel-reports">
                    <ReportsDashboardOffers
                      dateFilter={dateFilter}
                      onClick={(e) =>
                        this.buttonClickHandler(e, "seatingDdashboard")
                      }
                      dateTo={this.state.dateTo}
                      dateFrom={this.state.dateFrom}
                      onFromDateChange={this.onFromDateChange}
                      onToDateChange={this.onToDateChange}
                      onDateChange={this.changeDate}
                    />
                  </div>
                ) : null} */}
                {/* {this.state.displayTab === "events" ? (
                  <div className="w-100 bottom-side-panel-reports">
                    {/* <EventsReports /> 
                    <ReportsDashboardEvents
                      dateFilter={dateFilter}
                      onClick={(e) =>
                        this.buttonClickHandler(e, "eventsDashboard")
                      }
                      dateTo={this.state.dateTo}
                      dateFrom={this.state.dateFrom}
                      reportType={this.state.reportType}
                    />
                  </div>
                ) : null} */}

                {/* {this.state.displayTab === "eventstwo" ? (
                  <div className="w-100 bottom-side-panel-reports">
                    {/* <EventsReports /> 
                    <ReportsDashboardEvents
                      dateFilter={dateFilter}
                      onClick={(e) =>
                        this.buttonClickHandler(e, "eventsDashboard")
                      }
                      dateTo={this.state.dateTo}
                      dateFrom={this.state.dateFrom}
                      reportType={this.state.reportType}
                    />
                  </div>
                ) : null} */}
                {this.state.displayTab === "ordering" ? (
                  <div className="w-100 bottom-side-panel-reports">
                    {/* <EventsReports /> */}
                    <ReportsDashboardOrders
                      dateFilter={dateFilter}
                      onClick={(e) =>
                        this.buttonClickHandler(e, "orderDashboard")
                      }
                      dateTo={this.state.dateTo}
                      dateFrom={this.state.dateFrom}
                      reportType={this.state.reportType}
                    />
                  </div>
                ) : null}

                {/* {this.state.displayTab === "seatingDdashboard" ? (
                  <div className="col-12 ">
                    <SeatingReportsDashboard />
                  </div>
                ) : null} */}

                {this.state.displayTab === "eventsDashboard" ? (
                  <div className="col-12 ">
                    <EventsReports />
                  </div>
                ) : null}
              </div>
            </div>
            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default withRouter(SuperAdminMainReportsDashboard);
